<ul class="c-list" data-test-id="kontakt-list-root">
	@if (kontakteInVerfahren | async; as resource) {
	@for (kontakt of resource._embedded.kontaktInVerfahrenResList; track kontakt) {
		<li>
			<schir-int-client-kontakt-mit-kategorien [kontaktInVerfahren]="kontakt"
			                                         [verfahren]="verfahren"
			                                         (unassignKontakt)="unassignKontakt.emit($event)"/>
		</li>
	}
	}
</ul>
